// extracted by mini-css-extract-plugin
module.exports = {"hideOnMobile":"Common_hideOnMobile__3JPB_","hideOnDesktop":"Common_hideOnDesktop__e4CYd"};